// extracted by mini-css-extract-plugin
export default {"paramsCalc":"PropertiesForm_paramsCalc__jB+kN","calculator":"PropertiesForm_calculator__fwaCg"};